import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
    return (

        <div class="article">
        <h1>Политика конфиденциальности сервиса НачФин</h1>
        <div class="articlecontent">
            <div class="articleblock">
                <h2>Краткое описание политики</h2>
                <p>1.1. В настоящей Политике разъясняется наша процедура обработки Персональных данных.</p>
                <p>1.2. Настоящая Политика выпущена компанией ООО "НачФин" (далее "Оператор").</p>
                <p>1.3. Для отражения изменений в нашей практике Обработки Персональных данных или изменений применимого законодательства в настоящую Политику могут вноситься изменения и дополнения или обновления. Мы рекомендуем внимательно прочитать настоящую Политику и регулярно проверять данную страницу для просмотра изменений, которые мы можем вносить в условия настоящей Политики.</p>
                <p>1.4. Настоящая Политика рассчитана на лиц, которые не входят в нашу организацию, включая индивидуальных заказчиков, представителей.</p>
            </div>
            <div class="articleblock">
                <h2>Сбор персональных данных</h2>
                <p>2.1. Как правило, мы будем обрабатывать Персональные данные, получаемые от вас или собираемые у вас при покупке вами продукции, просмотре Веб-сайта, использовании Приложения или непосредственном взаимодействии с нами. Например, мы будем собирать или получать ваши Персональные данные в следующих случаях:</p>
                <p>2.1.1. мы собираем или получаем ваши Персональные данные в ходе обычных отношений с вами;</p>
                <p>2.1.2. при предоставлении нам Персональных данных напрямую (например, при обращении к нам по электронной почте, телефону или с помощью любых других средств связи, предоставлении своих контактных данных или отправке заявлений о приеме на работу);</p>
            </div>
        </div>
    </div>
            
    );
};

export default PrivacyPolicy;
